import React from "react";
import { View } from "react-native";

import IntegrationsHelper from "../../IntegrationsHelper";
import AccountEdit from "./AccountEdit";
import AccountsList from "./AccountsList";
import appPages from "../../../../../appPages";
import { navigate } from "../../../../../helpers/utils";
import SnoozeIntegrationDialog from "../../common/SnoozeIntegrationDialog";
import Disconnect from "./Disconnect";
import CalendarAccount from "../../onboarding/calendar/CalendarAccount";
import appStyles from "../../../../appStyles";
import Header from "../../../common/header/index";
import UsersHelper from "../../../users/UsersHelper";
import LoadingIndicator from "../../../common/LoadingIndicator";

export default class CalendarSyncPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    // After calendars selection go back to returnUrl
    const navState = props.navigation?.dangerouslyGetState() || {};
    const returnUrl = (navState.routes.slice(-2) || [])[0];

    const params = this.getArgs() || {};
    const calendarType = params.calendarType || "calendar_google";

    // For showing calendars page when users connects for the 1st time
    const email = params.email;

    let autotrackKey = calendarType;
    //TODO: fix inconsistency, both UI and backend needs cleanup
    if (calendarType == "calendar_google") autotrackKey = "google_calendar";
    else if (
      calendarType == "calendar_native" ||
      calendarType == "calendar_mobile"
    )
      autotrackKey = "mobile_calendar";

    this.state = {
      calendarType,
      autotrackKey,
      signInAccount: email ? { email } : null,
      accounts: this.controller.getDevices(autotrackKey),
      returnUrl: returnUrl?.name,
    };
  }

  getArgs() {
    if (this.controller.hasNavigation()) {
      return this.props.route.params;
    } else {
      return this.controller.state.screenArgs?.args;
    }
  }

  componentDidMount = async () => {
    if (this.controller.hasNavigation()) {
      this.focusListenerUnsub = this.props.navigation.addListener(
        "focus",
        () => {
          this.refreshPage();
        },
      );
    } else {
      this.refreshPage();
    }
  };

  refreshPage = async () => {
    const { autotrackKey } = this.state;
    this.setState((state) => ({
      ...state,
      accounts: this.controller.getDevices(autotrackKey),
    }));
  };

  componentWillUnmount = async () => {
    if (this.focusListenerUnsub) this.focusListenerUnsub();
  };

  goBack = () => {
    this.controller.goBack();
  };

  editAccount = (account) => {
    this.setState((state) => ({ ...state, account }));
  };

  saveIntegrations = (data, redirect = false) => {
    this.setState((state) => ({ ...state, isLoading: true }));

    IntegrationsHelper.saveIntegrationSource(this.controller, data, () => {
      this.setState((state) => ({
        ...state,
        snoozeAccount: null,
        disconnectAccount: null,
        isLoading: false,
      }));

      if (redirect) {
        this.controller.getItems(appPages.integrationsV2);
      }
    });
  };

  // ------------------------------------- SNOOZE -------------------------------------
  onCancel = (selectedAccount) => {
    const { accounts } = this.state;

    accounts.forEach((acc) => {
      if (acc.id == selectedAccount.id) acc.isEnabled = true;
    });

    this.setState((state) => ({ ...state, accounts, snoozeAccount: null }));
  };

  toggleAccountStatus = (account, isEnabled) => {
    const { calendarType } = this.state;

    if (!isEnabled) {
      this.setState((state) => ({ ...state, snoozeAccount: account }));
      return;
    }

    this.setState((state) => ({
      ...state,
      snoozeAccount: null,
      disconnectAccount: null,
    }));

    this.saveIntegrations({
      [calendarType]: isEnabled,
      isEnabled,
      account: account.email,
      id: account.id,
    });
  };

  showDisconnectPage = (acc) => {
    this.setState((state) => ({ ...state, disconnectAccount: acc }));
  };

  connectNewAccount = () => {
    const { calendarType } = this.state;
    IntegrationsHelper.reconnect(
      this.controller,
      calendarType,
      null,
      (type, events, email) => {
        this.setState({ signInAccount: email ? { email } : null });
      },
    );
  };

  // Snooze account
  turnOffAccount = () => {
    const { disconnectAccount } = this.state;
    this.toggleAccountStatus(disconnectAccount, false);
  };

  disconnectAccount = () => {
    const { calendarType, disconnectAccount, autotrackKey, accounts } =
      this.state;

    this.setState((state) => ({ ...state, isLoading: true }));

    IntegrationsHelper.saveIntegrationSource(
      this.controller,
      {
        [calendarType]: false,
        disconnect: true,
        id: disconnectAccount.id,
      },
      () => {
        const hasMultipleAccounts = accounts?.length > 1;

        this.controller.getApiData("settings", {}, () => {
          this.setState((state) => ({
            ...state,
            snoozeAccount: null,
            disconnectAccount: null,
            isLoading: false,
            accounts: hasMultipleAccounts
              ? this.controller.getDevices(autotrackKey) // refresh
              : accounts,
          }));

          // If user had only one account go back home
          if (!hasMultipleAccounts) {
            navigate(this.controller, appPages.integrationsV2);
          }
        });
      },
    );
  };

  // ------------------------------------- CALENDARS -------------------------------------
  onCalendarsContinue = () => {
    const { returnUrl, autotrackKey, calendarType } = this.state;

    // Integrations
    if (returnUrl == appPages.integrations) {
      // On calendars page user presses Continue
      IntegrationsHelper.saveIntegrationSource(
        this.controller,
        {
          [calendarType]: true,
          isEnabled: true,
        },
        () => {
          // Refesh
          this.controller.getApiData("settings", {}, (settings) => {
            const accounts = (settings?.devices || {})[autotrackKey] || [];

            this.setState((state) => ({
              ...state,
              signInAccount: null,
              disconnectAccount: null,
              accounts,
            }));
          });
        },
      );
      // Mapping Game
    } else if (returnUrl == appPages.integrationsMappingGame) {
      // Refesh
      this.controller.getApiData("settings", {}, () => {
        this.controller.navigate(returnUrl);
      });

      // Track
    } else {
      const isNewUser = UsersHelper.isNewUser(
        this.controller.state?.settings?.datetime_created,
      );

      if (isNewUser) {
        this.controller.navigate(appPages.homePage);
      } else {
        this.controller.goBack();
      }
    }
  };

  // ------------------------------------- RENDER -------------------------------------
  render() {
    const {
      accounts,
      account,
      autotrackKey,
      calendarType,
      disconnectAccount,
      snoozeAccount,
      signInAccount,
      isLoading,
    } = this.state;

    return (
      <>
        <LoadingIndicator isLoading={isLoading} />

        <SnoozeIntegrationDialog
          controller={this.controller}
          account={snoozeAccount}
          integrationName={calendarType}
          saveIntegrations={this.saveIntegrations}
          onCancel={this.onCancel}
        />

        {signInAccount ? (
          <View style={[appStyles.container, { backgroundColor: "#FFF" }]}>
            <Header
              title={signInAccount.email}
              subTitle="Choose which calendars to connect to Mana"
              goBack={this.goBack}
              returnPage={appPages.integrationsV2}
            />

            <CalendarAccount
              controller={this.controller}
              account={signInAccount}
              goBack={this.goBack}
              onContinue={this.onCalendarsContinue}
            />
          </View>
        ) : disconnectAccount ? (
          <Disconnect
            showDisconnectPage={this.showDisconnectPage}
            turnOffAccount={this.turnOffAccount}
            disconnectAccount={this.disconnectAccount}
          />
        ) : account ? (
          <AccountEdit
            controller={this.controller}
            account={account}
            calendarType={calendarType}
            editAccount={this.editAccount}
            saveIntegrations={this.saveIntegrations}
            disconnectAccount={this.showDisconnectPage}
          />
        ) : (
          <AccountsList
            controller={this.controller}
            calendarType={calendarType}
            accounts={accounts}
            autotrackKey={autotrackKey}
            goBack={this.goBack}
            editAccount={this.editAccount}
            disconnectAccount={this.showDisconnectPage}
            toggleAccountStatus={this.toggleAccountStatus}
            connectNewAccount={this.connectNewAccount}
          />
        )}
      </>
    );
  }
}
